import { useState } from "react";
import SellerStep from "../../components/seller/SellerStep";
import { SharedFormField } from "../../components/shared";
import ChoiceGroup from "../../components/forms/ChoiceGroup";
import CheckboxGroup from "../../components/forms/CheckboxGroup";
import { useSellerState } from "../../js/state/sellerState";

export default function SellerInteriorFeatures() {
  const saved = useSellerState().seller.portfolio.interiorFeatures || {};
  const [form, setForm] = useState({
    kitchen: saved.kitchen || [],
    kitchenLayout: saved.kitchenLayout || "",
    baths: saved.baths || [],
    flooring: saved.flooring || [],
    features: saved.features || [],
    bonusRooms: saved.bonusRooms || [],
    heating: saved.heating || "",
    cooling: saved.cooling || "",
    notes: saved.notes || "",
  });

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  return (
    <SellerStep
      title="Interior features"
      lead="Describe the home as it stands: kitchen, baths, flooring, and the rooms that sell the listing."
      sectionKey="interiorFeatures"
      value={form}
    >
      <section className="checklist-section">
        <h2>Kitchen</h2>
        <ChoiceGroup
          label="Layout"
          name="kitchenLayout"
          value={form.kitchenLayout}
          onChange={update}
          options={[
            { value: "galley", label: "Galley" },
            { value: "l-shape", label: "L-shape" },
            { value: "u-shape", label: "U-shape" },
            { value: "island", label: "Island / open" },
          ]}
        />
        <CheckboxGroup
          label="Kitchen highlights"
          name="kitchen"
          values={form.kitchen}
          onChange={update}
          layout="grid"
          options={[
            { value: "updated", label: "Updated cabinets / counters" },
            { value: "stainless", label: "Stainless appliances" },
            { value: "gas", label: "Gas range" },
            { value: "pantry", label: "Pantry" },
            { value: "quartz", label: "Stone / quartz counters" },
            { value: "eat-in", label: "Eat-in space" },
          ]}
        />
      </section>

      <section className="checklist-section">
        <h2>Baths & Surfaces</h2>
        <CheckboxGroup
          label="Bath highlights"
          name="baths"
          values={form.baths}
          onChange={update}
          layout="grid"
          options={[
            { value: "primary-ensuite", label: "Primary ensuite" },
            { value: "double-vanity", label: "Double vanity" },
            { value: "soaking", label: "Soaking tub" },
            { value: "walk-in-shower", label: "Walk-in shower" },
            { value: "updated", label: "Recently updated" },
          ]}
        />
        <CheckboxGroup
          label="Flooring present"
          name="flooring"
          values={form.flooring}
          onChange={update}
          layout="grid"
          options={[
            { value: "hardwood", label: "Hardwood" },
            { value: "lvp", label: "LVP / laminate" },
            { value: "tile", label: "Tile" },
            { value: "carpet", label: "Carpet" },
            { value: "concrete", label: "Concrete / other" },
          ]}
        />
      </section>

      <section className="checklist-section">
        <h2>Rooms & Systems</h2>
        <CheckboxGroup
          label="Architectural / interior features"
          name="features"
          values={form.features}
          onChange={update}
          layout="grid"
          options={[
            { value: "fireplace", label: "Fireplace" },
            { value: "built-ins", label: "Built-ins" },
            { value: "high-ceilings", label: "High ceilings" },
            { value: "smart-home", label: "Smart home" },
            { value: "office", label: "Dedicated office" },
            { value: "laundry", label: "In-home laundry" },
          ]}
        />
        <CheckboxGroup
          label="Bonus rooms"
          name="bonusRooms"
          values={form.bonusRooms}
          onChange={update}
          layout="grid"
          options={[
            { value: "basement", label: "Basement" },
            { value: "loft", label: "Loft" },
            { value: "sunroom", label: "Sunroom" },
            { value: "media", label: "Media / rec" },
            { value: "adu", label: "ADU / in-law" },
          ]}
        />
        <div className="two-col">
          <SharedFormField
            label="Heating"
            name="heating"
            type="select"
            value={form.heating}
            onChange={update}
            options={[
              { value: "forced-air", label: "Forced air" },
              { value: "heat-pump", label: "Heat pump" },
              { value: "radiant", label: "Radiant / boiler" },
              { value: "other", label: "Other" },
            ]}
          />
          <SharedFormField
            label="Cooling"
            name="cooling"
            type="select"
            value={form.cooling}
            onChange={update}
            options={[
              { value: "central", label: "Central AC" },
              { value: "heat-pump", label: "Heat pump" },
              { value: "mini-split", label: "Mini-split" },
              { value: "none", label: "None / window units" },
            ]}
          />
        </div>
        <SharedFormField
          label="Interior notes for my agent"
          name="notes"
          type="textarea"
          value={form.notes}
          onChange={update}
          placeholder="What a photographer or stager should know. Layout quirks, recent paint, what stays."
        />
      </section>
    </SellerStep>
  );
}
